namespace $ {
	const { rem } = $mol_style_unit

	$mol_style_define($exso_sheets_app, {
		Menu: {
			flex: { basis: rem(18), grow: 0 },
		},

		Menu_title: {
			flex: { grow: 1 },
		},

		$mol_page: {
			':not([mol_book2_catalog_menu], [mol_book2_catalog_placeholder])': {
				flex: { basis: rem(40), grow: 1, shrink: 0 },
				background: { color: $mol_theme.back },
			},
		},
		$mol_card: {
			boxShadow: 'none',
		},
	})
}
